import { render, staticRenderFns } from "./BuyBoxNoOffersNew.vue?vue&type=template&id=d09cef34&scoped=true"
import script from "./BuyBoxNoOffersNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxNoOffersNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxNoOffersNew.vue?vue&type=style&index=0&id=d09cef34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09cef34",
  null
  
)

export default component.exports